import PriorityBadgeManager from './priority_badge_manager';

export default PriorityBadgeManager;
